import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/http/api.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { AuthenticationCheckService } from 'src/app/services/auth/authentication-check.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  loginForm: FormGroup;
  submitted: boolean = false;
  inputPasswordType: string = 'password';

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    private auth: AuthenticationCheckService,
    private toast: ToastClientService
  ) { }

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email_id: ['', [Validators.required, Validators.email]],
      password_hash: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  // Toggle password visibility
  toggleShowPassword(): void {
    this.inputPasswordType = this.inputPasswordType === 'password' ? 'text' : 'password';
  }

  // Login function
  login(): void {
    this.submitted = true;

    if (this.loginForm.invalid) {
      return;
    }

    const apiUrl = this.apiConfig.login;
    const formData = this.loginForm.value;

    const body = { LoginForm: formData };

    this.apiService.post(apiUrl, JSON.stringify(body))
      .subscribe(
        (res: any) => {
          if (res.status === 200) {
            const userData = res.body.data;

            this.toast.Success('Login successful');
            localStorage.setItem('user_name', userData.user_name);
            localStorage.setItem('user_id', userData.id);
            localStorage.setItem("campaign_id", (userData.campaign_id));

            this.auth.saveAuth(userData.access_token);

            this.router.navigate([userData.role_name === 'hubadmin' ? 'users' : 'reports']);
          } else {
            this.toast.Error('Invalid response from server');
          } 
        },
        (err) => {
          if (err.status === 400 || err.status === 401) {
            this.toast.Error('Incorrect username or password');
          } else {
            this.toast.Error('An unexpected error occurred. Please try again.');
          }
        }
      );
  }
}
